/* eslint-disable*/
import React from "react";
import SystemMaintenanceSpecialFunctions_CompanySetup from "./CompanySetup";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("CompanySetup Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<SystemMaintenanceSpecialFunctions_CompanySetup />);
    });
  });
  afterEach(cleanup);
  test("is CompanySetup Loads Successfully", () => {
    expect(screen.getByText("CompanySetup")).toBeInTheDocument;
  });
  test("Custom Test Cases for CompanySetup", () => {
    // START_USER_CODE-USER_CompanySetup_Custom_Test_Case
    // END_USER_CODE-USER_CompanySetup_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<SystemMaintenanceSpecialFunctions_CompanySetup />);
    });
  });
  afterEach(cleanup);
  test("btnAdd(Button Widget) Test Cases", async () => {
    const btnAdd = screen.getByTestId("btnAdd");
    expect(btnAdd).toBeInTheDocument;
    expect(btnAdd.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:CompanySetup_btnAdd")
    );
  });
  test("Custom Test Cases for btnAdd", () => {
    // START_USER_CODE-USER_btnAdd_TEST
    // END_USER_CODE-USER_btnAdd_TEST
  });
  test("btnClose(Button Widget) Test Cases", async () => {
    const btnClose = screen.getByTestId("btnClose");
    expect(btnClose).toBeInTheDocument;
    expect(btnClose.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:CompanySetup_btnClose")
    );
  });
  test("Custom Test Cases for btnClose", () => {
    // START_USER_CODE-USER_btnClose_TEST
    // END_USER_CODE-USER_btnClose_TEST
  });
  test("btnDelete(Button Widget) Test Cases", async () => {
    const btnDelete = screen.getByTestId("btnDelete");
    expect(btnDelete).toBeInTheDocument;
    expect(btnDelete.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:CompanySetup_btnDelete")
    );
  });
  test("Custom Test Cases for btnDelete", () => {
    // START_USER_CODE-USER_btnDelete_TEST
    // END_USER_CODE-USER_btnDelete_TEST
  });
  test("btnEdit(Button Widget) Test Cases", async () => {
    const btnEdit = screen.getByTestId("btnEdit");
    expect(btnEdit).toBeInTheDocument;
    expect(btnEdit.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:CompanySetup_btnEdit")
    );
  });
  test("Custom Test Cases for btnEdit", () => {
    // START_USER_CODE-USER_btnEdit_TEST
    // END_USER_CODE-USER_btnEdit_TEST
  });
  test("grpbxCompanySetup(GroupBox Widget) Test Cases", async () => {
    const grpbxCompanySetup = screen.getByTestId("grpbxCompanySetup");
    expect(grpbxCompanySetup.tagName).toBe("BUTTON");
    expect(grpbxCompanySetup.type).toBe("button");
    expect(grpbxCompanySetup.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxCompanySetup", () => {
    // START_USER_CODE-USER_grpbxCompanySetup_TEST
    // END_USER_CODE-USER_grpbxCompanySetup_TEST
  });
  test("lblCompanyList(Label Widget) Test Cases", async () => {
    const lblCompanyList = screen.getByTestId("lblCompanyList");
    expect(lblCompanyList.tagName).toBe("LABEL");
    expect(lblCompanyList.classList).toContain("form-label");
    expect(lblCompanyList.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:CompanySetup_lblCompanyList")
    );
  });
  test("Custom Test Cases for lblCompanyList", () => {
    // START_USER_CODE-USER_lblCompanyList_TEST
    // END_USER_CODE-USER_lblCompanyList_TEST
  });
});
